import { createContext, useContext, useMemo } from 'react'

const CategoryContext = createContext()

/**
 *
 * @param {Object} props
 * @param {Object} props.category - Category object
 * @param {string} props.category.id - Category id
 * @param {React.ReactNode} props.children - React children
 * @returns {React.ReactNode} React children wrapped in CategoryContext.Provider
 */
const CategoryProvider = ({ children, category }) => {
	if (!category) {
		// console.warn('Use of CategoryProvider without category prop is useless. Remove it or provide a category prop.')
		category = {}
	}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const contextValue = useMemo(() => [category], [category?.id])

	return <CategoryContext.Provider value={contextValue}>{children}</CategoryContext.Provider>
}

export default CategoryProvider

export const useCategoryContext = () => {
	const categoryContextValue = useContext(CategoryContext)
	if (!categoryContextValue || !categoryContextValue[0]?.id) {
		// console.warn(
		// 	`Category context value or category prop is missing. Verify that CategoryProvider is a parent of the current component and category prop is provided to it.`
		// )
	}

	return categoryContextValue
}
